import HttpService from "../../constant/Api";

const API = "v1/lawone/subscriber";

export const removeDataReqService = () => {
  return HttpService.post(API);
};

export const sendVerifyCodeService = (code) => {
  return HttpService.delete(`${API}/${code}`);
};
